// SPDX-License-Identifier: LicenseRef-VicZhuProprietary
// SPDX-FileCopyrightText: 2026 Vic Zhu <viczhu2014@gmail.com>

import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { routeToUsageEvent, track } from './usageTracker'

/**
 * One page-view (or patient-view) usage event per route change (vic/vetpo#49).
 * Mounted once, in the authenticated Layout, so every portal section is
 * covered without touching each page — and nothing is recorded on the login
 * screen or the pre-Admin invite/SSO pages. Keyed on pathname only: a query
 * string change (filters, pagination) is not a new page.
 */
export function useUsagePageViews(): void {
  const { pathname } = useLocation()
  useEffect(() => {
    track(routeToUsageEvent(pathname))
  }, [pathname])
}
